export enum Theme {
  A2EI = 'a2ei',
  ABER = 'aber',
  ABERBURKINAFASO = 'aberburkinafaso',
  AGER = 'ager',
  AGREE = 'agree',
  AMADER = 'amader',
  AMADERMALI = 'amadermali',
  AMAP = 'amap',
  ANPER = 'anper',
  ANPERNIGER = 'anperniger',
  ARENE = 'arene',
  ASER = 'aser',
  AVORENEWABLES = 'avorenewables',
  BENIN = 'benin',
  BRILHO = 'brilho',
  BURUNDI = 'burundi',
  CB = 'cb',
  CEIAFRICA = 'ceiafrica',
  CPI = 'cpi',
  DARES = 'dares',
  DB = 'db',
  DECIM = 'decim',
  DREAMETHIOPIA = 'dream-ethiopia',
  EARF = 'earf',
  ECREEE = 'ecreee',
  EEU = 'eeu',
  EPP = 'epp',
  ESMAPHFE = 'esmap-hfe',
  ESSOR = 'essor',
  FUNAE = 'funae',
  FONDSDECIM = 'fondsdecim',
  GBEBENIN = 'gbe-benin',
  GBECOTEDIVOIRE = 'gbe-cotedivoire',
  GUINEABISSAUSESAP = 'guineabissau-sesap',
  IFC = 'ifc',
  IPFF = 'ipff',
  NEA = 'nea',
  NERC = 'nerc',
  OGEF = 'ogef',
  OMDF = 'omdf',
  ODYSSEY = 'odyssey',
  PAOP = 'paop',
  PHARES = 'phares',
  POWERTRUST = 'powertrust',
  PROENERGIA = 'proenergia',
  REA = 'rea',
  REAEEI = 'reaeei',
  REAREF = 'rearef',
  RENSOURCE = 'rensource',
  RMI = 'rmi',
  RREA = 'rrea',
  RREALIBERIA = 'rrealiberia',
  SOLEILNYAKIRIZABI = 'soleil-nyakiriza-bi',
  SOMALILAND = 'somaliland',
  SUNAFRICA = 'sun-africa',
  TCHAD = 'tchad',
  TDBGROUP = 'tdbgroup',
  UEF = 'uef',
}
